import { render, staticRenderFns } from "./areadata.vue?vue&type=template&id=74805d27"
import script from "./areadata.vue?vue&type=script&lang=js"
export * from "./areadata.vue?vue&type=script&lang=js"
import style0 from "./areadata.vue?vue&type=style&index=0&id=74805d27&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports